import {
    apiRequest,
    punishmentCreate,
    punishmentListParent,
    punishmentListType,
    punishmentListSignatory
} from "../../../../../services/adapters/master/punishmentService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", punishmentCreate, {
            body: query
        }, true)
    }

    fetchSignatoryOfficial = async (query) => {
        return await apiRequest("get", punishmentListSignatory, {
            params: query
        }, true)
    }

    fetchParent = async (query) => {
        return await apiRequest("get", punishmentListParent, {
            params: query
        }, true)
    }

    fetchType = async (query) => {
        return await apiRequest("get", punishmentListType, {
            params: query
        }, true)
    }

}

export default CreateRepository